import React, { Component } from "react";
import avatar from "../../../assets/images/avatar.svg";
import trophyIcon from "../../../assets/images/icons/trophy.svg";
import { Redirect } from "react-router";
import * as gameAction from "../../../redux/game/action";
import { connect } from "react-redux";
import Trophies from "../../../assets/images/GAH/Trophies.png";
import ResultBanner from "../../../assets/images/GAH/result-banner.svg";
import PlayerImage from "../../../assets/images/GAH/Player.png";
import finalResultBanner from "../../../assets/images/GAH/final-result-banner.svg";

class Win_Lose extends Component {
  componentDidMount() {
    this.props.setFlippedCard([]);
  }

  render() {
    let roomData = this.props.gameReducer.roomObj;
    let winnerOfGame = "";
    let playerHands = [];
    if (roomData?.game_state?.player_hands) {
      playerHands = roomData.game_state.player_hands;
      winnerOfGame = playerHands.findIndex(
        (user) =>
          user.score === roomData.game_state.game_parameters.score_to_win
      );
    }
    let winnerPlayer = "";

    if (winnerOfGame >= 0) {
      winnerPlayer = roomData.users.filter(
        (user) => user.player_id === playerHands[winnerOfGame].player_id
      );
      winnerPlayer = winnerPlayer[0];
    }
    let playerName = winnerPlayer.display_name.split(" ");

    if (roomData) {
      if (roomData.game_state && roomData.game_state.status) {
        if (roomData.game_state.status === "PrePlay") {
          return <Redirect to={"/game"} />;
        }
        if (roomData.game_state.status === "Joining") {
          return <Redirect to={"/lobby"} />;
        }
      }
    }

    return (
      <div className="gah-gamesWrapper">
        <div className="win-results">
          <img src={Trophies} alt="" />
          <div className="winner-text">
            <img src={finalResultBanner} alt="" />
            <p className="title">
              <span>{winnerPlayer ? playerName[0] : ""} WINS!</span>
            </p>
          </div>
        </div>
        <div className="win-image">
          <span className="winner-player-image">
            <img src={winnerPlayer ? winnerPlayer.profile_image : ""} />
          </span>
        </div>
      </div>
      // <div className="gamesWrapper">
      //   <div className="resultCard win text-center">
      //     <div className="w-100">
      //       <div className="wrapper">
      //         <div className="profileWrapper">
      //           <img
      //             className="profile"
      //             src={
      //               winnerPlayer && winnerPlayer.profile_image
      //                 ? winnerPlayer.profile_image
      //                 : avatar
      //             }
      //             alt="player"
      //           />
      //           <img className="trophyIcon" src={trophyIcon} />
      //         </div>
      //       </div>

      //       <h2 className="title">
      //         {winnerPlayer ? winnerPlayer.display_name : ""} Wins!
      //       </h2>
      //     </div>
      //   </div>
      // </div>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});
const mapDispatchToProps = (dispatch) => {
  return {
    setFlippedCard: (data) => dispatch(gameAction.setFlippedCard(data))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Win_Lose);
